import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {useLocation} from '@app/hooks/use-location';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const OfflineDevices: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'offlinelandingpage_title_downloadmusiconyourdevices_standalone-web',
							{ns: 'offline'},
						)}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'offlinelandingpage_text_downloadmusiconyourdevices_standalone-web',
							{ns: 'offline'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '250px', md: '100%'}}
					sizes={{base: '100vw', md: '50vw'}}
					src="fec3dbdd7b6862582f72566b85164d81.jpg"
					aspectRatio="867/577"
					alt={t('metatag_text_listentomusicofflinealldevices_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover-devices'}}
					href={getDeezerUrl('/devices/wearables')}
					target="_blank"
				>
					{t('generic_action_seealldevices_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
